import React, { useEffect, useId, useState } from 'react'
import ReactSelect, { Props } from 'react-select'
function CustomSelect({
	options,
	getOptionLabel = (param: any) => param?.label as string,
	getOptionValue = (param: any) => param?.value as string,
	className = '',
	defaultValue,
	value,
	id,
	controlClass,
	...rest
}: Props & Record<string, any>) {
	const [selected, setSelected] = useState(defaultValue || value)
	useEffect(() => {
		if (value) setSelected(value)
		else setSelected(null)
	}, [value])
	const uniqId = useId()
	// function handleChange(...o) {
	// 	setSelected(o)
	// 	onChange && onChange(...o)
	// }

	// const handleSearch = debounce(({ target }) => {
	// 	setMenu(searchFromArray(options, target.value, labelKey))
	// 	inputRef.current.value = target.value
	// 	inputRef.current.focus()
	// 	!isStatic && setSelected({ sName: target.value })
	// 	onInputChange && onInputChange(target.value)
	// })

	// function handleScroll(e) {
	// 	if (isBottomReached && bottomReached(e)) isBottomReached(e)
	// }

	// function onClear() {
	// 	onChange(null)
	// 	setSelected(placeholderInner)
	// }

	return (
		<ReactSelect
			className={`text-sm font-medium cursor-pointer ${className}`}
			isMulti={false}
			options={options}
			// menuIsOpen
			key={uniqId}
			id={id || uniqId}
			getOptionLabel={getOptionLabel}
			getOptionValue={getOptionValue}
			classNames={{
				control: () => `!bg-headersActive !border-tabBorder !shadow-none !rounded-lg !cursor-pointer ${controlClass}`,
				menu: () => 'dark:!bg-[#131A1E] !bg-white !border-0 !border-c !rounded-lg !z-50 relative !shadow-lg',
				input: () => '!text-t-origin',
				menuList: () => '!px-3 !py-1 scroll-smooth !z-50 relative',
				singleValue: () => '!text-t-origin',
				group: () => '!pt-2',
				groupHeading: () => '!bg-button-dark !rounded-md',
				option: (params) => {
					const [selected] = params.getValue()
					const isSelected =
						getOptionLabel(params?.data) === getOptionLabel(selected) && getOptionValue(params?.data) === getOptionValue(selected)
					return `!z-50 relative !text-textOffWhite font-medium !py-2 !px-2 !my-1 dark:hover:!bg-[#0D1318] !border-0 !rounded-lg  hover:!border-c !cursor-pointer ${
						isSelected || params.isFocused ? 'dark:!bg-[#0D1318] !bg-[#F8F8F8]' : '!bg-transparent'
					}`
				},

				indicatorsContainer: () => '!text-textDselected',
				dropdownIndicator: () => '!text-textDselected hover:!text-textDselected',
			}}
			components={{
				IndicatorSeparator: () => null,
			}}
			{...rest}
			value={selected}
		/>
	)
}

export default CustomSelect
